// See docs/fdc/navigation-progress-bar.md for architecture and design decisions.
import { useNavigationProgress } from '@fdc/components/layout/navigation-progress-provider/navigation-progress-context';
import { START_DELAY_MS } from '@fdc/components/layout/navigation-progress-provider/navigation-progress.constants';
import { useRouter } from 'next/navigation';

const isSameUrl = (href: Parameters<ReturnType<typeof useRouter>['push']>[0]) =>
  typeof href === 'string' &&
  typeof window !== 'undefined' &&
  href === `${window.location.pathname}${window.location.search}`;

export const useAppRouter = () => {
  const nextRouter = useRouter();
  const { start } = useNavigationProgress();

  return {
    ...nextRouter,
    push: (...args: Parameters<typeof nextRouter.push>) => {
      if (!isSameUrl(args[0])) {
        start(START_DELAY_MS);
      }
      nextRouter.push(...args);
    },
    replace: (...args: Parameters<typeof nextRouter.replace>) => {
      if (!isSameUrl(args[0])) {
        start(START_DELAY_MS);
      }
      nextRouter.replace(...args);
    },
    back: () => {
      start(START_DELAY_MS);
      nextRouter.back();
    },
    forward: () => {
      start(START_DELAY_MS);
      nextRouter.forward();
    },
  };
};
